export default {"src":"/_next/static/media/omaha-logo-new-horizontal.d7d82e15.svg","height":32,"width":180,"blurWidth":0,"blurHeight":0};